export const S3Config = {
    S3PresignedURLAPI: "https://gy53zlonl6.execute-api.me-south-1.amazonaws.com/S3presignedURLForFileUpload",
    S3ObjectBaseURL: "https://mycaas-test-bucket.s3.me-south-1.amazonaws.com/",
    S3ObjectDelimiter: "|::|",
    NDAHTMLFILE : "https://mycaas-test-bucket.s3.me-south-1.amazonaws.com/acknowledgements/NDA_General_caas_v2.html"
}